import React, { useState } from "react";
import LOGO from "../assets/images/Globelink.png";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav className="bg-white shadow-md w-full fixed top-0 left-0 z-50">
      <div className="container mx-auto px-6 py-4 flex items-center justify-between">
        {/* Logo */}
        <div className="flex items-center">
          <img src={LOGO} alt="Globelink Logo" className="h-15" />
        </div>

        {/* Navigation Links (Hidden on Mobile) */}
        <div className="hidden md:flex gap-10">
          {[
            { name: "Home", link: "/" },
            { name: "About", link: "/about" },
            { name: "Services", link: "/services" },
            { name: "Contact", link: "/contact" },
            { name: "Career", link: "/career" },
          ].map((item, index) => (
            <a
              key={index}
              href={item.link}
              className="text-[#000000] font-semibold hover:text-[#75000E] border-b-2 border-transparent hover:border-black transition"
            >
              {item.name}
            </a>
          ))}
        </div>

        {/* Sign Up Button */}
        <div className="hidden md:block">
          <a
            href="/register"
            className="bg-[#012647] font-sans text-white px-4 py-2 rounded-lg hover:bg-[#75000e] transition"
          >
            Sign Up
          </a>
        </div>

        {/* Mobile Menu Button */}
        <div className="md:hidden">
          <button
            className="text-gray-700 focus:outline-none"
            onClick={() => setIsOpen(!isOpen)}
          >
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d={isOpen ? "M6 18L18 6M6 6l12 12" : "M4 6h16M4 12h16m-7 6h7"}
              />
            </svg>
          </button>
        </div>
      </div>

      {/* Mobile Menu - Fullscreen Dropdown */}
      <div
        className={`fixed top-0 left-0 w-full h-full bg-white z-40 transform ${
          isOpen ? "translate-x-0 opacity-100" : "-translate-x-full opacity-0"
        } transition-transform duration-300 ease-in-out`}
      >
        <div className="flex flex-col h-full items-center justify-center space-y-6">
          {[
            { name: "Home", link: "/" },
            { name: "About", link: "/about" },
            { name: "Services", link: "/services" },
            { name: "Contact", link: "/contact" },
            { name: "Career", link: "/career" },
          ].map((item, index) => (
            <a
              key={index}
              href={item.link}
              className="text-[#000000] text-xl font-semibold hover:text-[#75000E] border-b-2 border-transparent hover:border-black transition"
              onClick={() => setIsOpen(false)}
            >
              {item.name}
            </a>
          ))}
          <a
            href="/register"
            className="bg-[#012647] text-white px-6 py-3 rounded-lg hover:bg-[#75000e] transition"
            onClick={() => setIsOpen(false)}
          >
            Sign Up
          </a>
        </div>

        {/* Close Button */}
        <button
          className="absolute top-6 right-6 text-gray-700 focus:outline-none"
          onClick={() => setIsOpen(false)}
        >
          <svg
            className="w-8 h-8"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
      </div>
    </nav>
  );
};

export default Navbar;
